import { eventObserver, delegateObserver } from '../dom/dom';
import { Observable, Subscription, fromEvent  } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { Timeline, TimelineEvents } from './timeline';
import { Application } from '../application/application';
import  flatpickr  from 'flatpickr';
import * as moment from 'moment';

declare let com:any;//for as long we have legacy code i.e. Timeline has not been implemented in TS yet


export enum TimelineControlButtons {
    ANIMATION_STOP = 'stop',
    ANIMATION_START = 'start',
    ANIMATION_PAUSE = 'pause',
    SYNCHRONIZE = 'synchronize',
    RESET = 'reset',
    ZOOM_IN = 'zoomIn',
    ZOOM_OUT = 'zoomOut',
    CONTROL = 'control'
}

export class TimelineControls {

    public container:HTMLDivElement; 
    private timeline: Timeline;
    private timelineSubscription:Subscription;

    private buttonSelectors: {[key in TimelineControlButtons]?:  string };
    private clickSubscriptions: {[key in TimelineControlButtons]?:  Subscription };
    private buttonCheckers: {[key in TimelineControlButtons]?:  () => boolean };
    private buttonUpdaters: {[key in TimelineControlButtons]?:  () => void };
    private rangeClickSubscription: Subscription;
    private applyClickSubscription: Subscription;
    
    private startPicker: flatpickr.Instance;
    private endPicker: flatpickr.Instance;
    private lastModifiedDate: Date;
    private addDuration: boolean;

    constructor( containerSelector: string ){
        this.container = <HTMLDivElement>document.querySelector(containerSelector);
        this.timeline = undefined;
        this.timelineSubscription = undefined;
        
        if( this.container && this.container.tagName === 'DIV'){
            let buttonSelectorPrefix = ' div.timeline-buttons ';
            this.buttonSelectors = {
                    [TimelineControlButtons.ANIMATION_STOP] : 'a.stop',
                    [TimelineControlButtons.ANIMATION_START] : 'a.start',
                    [TimelineControlButtons.ANIMATION_PAUSE] : 'a.pause',
                    [TimelineControlButtons.SYNCHRONIZE] : 'a.synchronize',
                    [TimelineControlButtons.RESET] : 'a.reset',
                    [TimelineControlButtons.ZOOM_IN] : 'a.zoomIn',
                    [TimelineControlButtons.ZOOM_OUT] : 'a.zoomOut',
                    [TimelineControlButtons.CONTROL] : 'a.control'
            };
            const buttonUpdater = (button : TimelineControlButtons) : HTMLElement => {
                const elem = <HTMLElement>this.container.querySelector(`div.timeline-buttons ${this.buttonSelectors[button]}`);
                if( this.getTimeline() ){
                    if(elem){
                        elem.style.display = '';
                    }
                    elem.blur();
                    return elem
                } else{
                    if(elem){
                        elem.style.display = 'none'; 
                        elem.blur();
                    }
                    return undefined;
                }
                
            }
            
            const buttonKiller = ( button : TimelineControlButtons) => {
                const elem = buttonUpdater( button );
                const state = this.buttonCheckers[button]();
                //console.log('%s -> %s',button,state);
                if(elem){
                    elem.style.display = state ? '' : 'none'; 
                }
            }
            const buttonHider = ( button : TimelineControlButtons) => {
                const elem = buttonUpdater( button );
                const state = this.buttonCheckers[button]();
                //console.log('%s -> %s',button,state);
                if(elem){
                    elem.style.visibility = state ? 'visible' : 'hidden'; 
                }
            }
            const buttonToggler = ( button : TimelineControlButtons, toggleClass: string) => {
                const elem = buttonUpdater( button );
                const state = this.buttonCheckers[button]();
                //console.log('%s -> %s',button,state);
                if(elem){
                    elem.classList.toggle( toggleClass, !state );
                }
            }
            
            this.buttonCheckers = {
                    [TimelineControlButtons.ANIMATION_STOP] : () => this.getTimeline() && this.getTimeline().isCursorVisible() ,
                    [TimelineControlButtons.ANIMATION_START] : () => this.getTimeline() && this.getTimeline().isCursorAnimationEnabled() && ( this.getTimeline().inSimpleMode()  || this.getTimeline().isCursorAnimationPaused() ) ,
                    [TimelineControlButtons.ANIMATION_PAUSE] : () => this.getTimeline() && this.getTimeline().isAnimating(),
                    [TimelineControlButtons.SYNCHRONIZE] : () => this.getTimeline() && this.getTimeline().isTimeSynchronisationEnabled() && !this.getTimeline().isSynchronizing() ,
                    [TimelineControlButtons.RESET] : () => this.getTimeline() && this.getTimeline().isLagging() ,
                    [TimelineControlButtons.ZOOM_IN] : () => this.getTimeline() && true ,
                    [TimelineControlButtons.ZOOM_OUT] : () => this.getTimeline() && true ,
                    [TimelineControlButtons.CONTROL] : () => this.getTimeline() && true 
            }
            this.buttonUpdaters = {
                    [TimelineControlButtons.ANIMATION_STOP] : () => {
                        const elem = buttonUpdater( TimelineControlButtons.ANIMATION_STOP );
                        if(elem){
                            if( this.getTimeline().isCursorEnabled() ){
                                elem.style.display = ''; 
                                const state = this.buttonCheckers[TimelineControlButtons.ANIMATION_STOP]();
                                elem.classList.toggle( 'active', state );
             //                   elem.style.visibility = state ? 'visible' : 'hidden'; 
                            }else{
                                elem.style.display = 'none'; 
                            }
                        }
                    },
                    [TimelineControlButtons.ANIMATION_START] : () => buttonKiller(TimelineControlButtons.ANIMATION_START) ,
                    [TimelineControlButtons.ANIMATION_PAUSE] : () => buttonKiller(TimelineControlButtons.ANIMATION_PAUSE) ,
                    [TimelineControlButtons.SYNCHRONIZE] : () => buttonToggler(TimelineControlButtons.SYNCHRONIZE, 'active') ,
                    [TimelineControlButtons.RESET] : () => buttonToggler(TimelineControlButtons.RESET,'disabled') ,
                    [TimelineControlButtons.ZOOM_IN] : () => buttonKiller(TimelineControlButtons.ZOOM_IN) ,
                    [TimelineControlButtons.ZOOM_OUT] : () => buttonKiller(TimelineControlButtons.ZOOM_OUT) ,
                    [TimelineControlButtons.CONTROL] : () => buttonKiller(TimelineControlButtons.CONTROL) 
            }
            
            //date time pickers
            
            const onDatetimePickerChange = ( selectedDates:Date[], dateStr:string, picker:flatpickr.Instance) => {
                this.lastModifiedDate = selectedDates[0];
                this.addDuration = picker.input.classList.contains('start');
            }
            
            const onSetRangeClick = ( rangeButton: HTMLElement ) => {
                const durationUnit:moment.unitOfTime.DurationConstructor  = <moment.unitOfTime.DurationConstructor>rangeButton.dataset.durationUnit;
                const duration = parseFloat(rangeButton.dataset.duration);
                
                const range: moment.Duration = moment.duration( duration, durationUnit );

                let start, end;
                if( this.addDuration !== false ){
                    start = this.lastModifiedDate === undefined ? moment(this.startPicker.selectedDates[0]) : moment(this.lastModifiedDate);
                    end = start.clone().add(range);
                } else {
                    end = moment(this.lastModifiedDate);
                    start = end.clone().subtract( range );
                }
                this.startPicker.setDate( new Date( start.valueOf() ) );
                this.endPicker.setDate( new Date( end.valueOf() ) );
            }
            
            const onApplyClick = ( okButton: HTMLElement ) => {
                let start = this.startPicker.selectedDates[0].getTime();
                let end = this.endPicker.selectedDates[0].getTime();
                if( start >= end ){
                    if(start === end ){
                        end = moment(start).add( moment.duration( 1, 'days' ) ).valueOf();
                        this.endPicker.setDate( new Date( end ) );
                    } else {
                        this.startPicker.setDate( new Date( end ) );
                        this.endPicker.setDate( new Date( start ) );
                    }
                    
                    start = this.startPicker.selectedDates[0].getTime();
                    end = this.endPicker.selectedDates[0].getTime();
                }
                
                this.getTimeline().setRange(start, end);
                
                (<HTMLDivElement>this.container.querySelector('div.pseudo-window')).classList.remove('open');

            }
            
            //this observer emits mouse clicks with the default prevented and only when a timeline has been set
            let topClickObs = eventObserver( this.container, 'click', { passive: false} ).pipe( filter(clickEvt => this.getTimeline()!==undefined ), tap(clickEvt => clickEvt.preventDefault() ) );
            
            this.rangeClickSubscription = delegateObserver( this.container, topClickObs, 'div.pseudo-window div.buttons.range a').subscribe( evt => {
                onSetRangeClick(evt.target);
            });
            this.applyClickSubscription = delegateObserver( this.container, topClickObs, 'div.pseudo-window div.buttons.misc a.apply').subscribe( evt => {
                onApplyClick(evt.target);
            })
            
            //define this helper for creating delegated click observers to the TimelineControlButtons 
            const clickObs = ( button: TimelineControlButtons ) => delegateObserver( this.container, topClickObs, `div.timeline-buttons ${this.buttonSelectors[ button ]}`  );
            
            this.clickSubscriptions = {
                    [TimelineControlButtons.ANIMATION_STOP] : clickObs(TimelineControlButtons.ANIMATION_STOP).subscribe( evt => this.getTimeline().showCursor(!this.getTimeline().isCursorVisible()) ),
                    [TimelineControlButtons.ANIMATION_START] : clickObs(TimelineControlButtons.ANIMATION_START).subscribe( evt => this.getTimeline().startAnimation() ),
                    [TimelineControlButtons.ANIMATION_PAUSE] : clickObs(TimelineControlButtons.ANIMATION_PAUSE).subscribe( evt => this.getTimeline().pauseAnimation(true) ),
                    [TimelineControlButtons.SYNCHRONIZE] : clickObs(TimelineControlButtons.SYNCHRONIZE).subscribe( evt => this.getTimeline().synchronize( !this.getTimeline().isSynchronizing() ) ),
                    [TimelineControlButtons.RESET] : clickObs(TimelineControlButtons.RESET).subscribe( evt => this.getTimeline().reset() ),
                    [TimelineControlButtons.ZOOM_IN] : clickObs(TimelineControlButtons.ZOOM_IN).subscribe( evt => this.getTimeline().zoom(1) ),
                    [TimelineControlButtons.ZOOM_OUT] : clickObs(TimelineControlButtons.ZOOM_OUT).subscribe( evt => this.getTimeline().zoom(-1) ),
                    [TimelineControlButtons.CONTROL] : clickObs(TimelineControlButtons.CONTROL).subscribe( evt => {
                        let rangeWindow = <HTMLDivElement>this.container.querySelector('div.pseudo-window');
                        if(!rangeWindow.classList.contains('open')){
                            let startInput = <HTMLElement>this.container.querySelector(`input.tlmd-datetimepicker.start`);
                            let endInput = <HTMLElement>this.container.querySelector(`input.tlmd-datetimepicker.end`);
                            this.startPicker = flatpickr( startInput, { enableTime:true, appendTo: startInput.parentElement, disableMobile: true, onChange:onDatetimePickerChange } );
                            this.endPicker = flatpickr( endInput, { enableTime:true, appendTo: endInput.parentElement, disableMobile: true, onChange:onDatetimePickerChange  } );

                            this.lastModifiedDate = undefined;
                            this.addDuration = undefined;

                            const range = this.getTimeline().getTimeRange(false);
                            this.startPicker.setDate( new Date(range.visible.start) );
                            this.endPicker.setDate( new Date(range.visible.end) );
                        } else {
                            
                            this.startPicker.destroy();
                            this.endPicker.destroy();
                            this.startPicker = undefined;
                            this.endPicker = undefined;
                        }
                        rangeWindow.classList.toggle('open'); 
                    } )
            };

            /*
            let startInput = <HTMLElement>this.container.querySelector(`input.tlmd-datetimepicker.start`);
            let endInput = <HTMLElement>this.container.querySelector(`input.tlmd-datetimepicker.end`);
            this.startPicker = flatpickr( startInput, { enableTime:true, appendTo: startInput.parentElement, disableMobile: true, onChange:onDatetimePickerChange } );
            this.endPicker = flatpickr( endInput, { enableTime:true, appendTo: endInput.parentElement, disableMobile: true, onChange:onDatetimePickerChange  } );
            */
            
        } else {
            throw `Container '${containerSelector}' did not yield a DIV element. Unable to setup TimelineControls.`;
        }
    }
    
    setTimeline( timeline : Timeline ): TimelineControls {
        if(this.timelineSubscription && !this.timelineSubscription.closed){
            this.timelineSubscription.unsubscribe();
            this.timelineSubscription = undefined;
        }
        
        this.timeline = timeline ? timeline : undefined;
        if(this.timeline){
            this.timelineSubscription = eventObserver( this.timeline.getContainer(), TimelineEvents.UPDATE_CONTROLS ).subscribe( event => this.update() );
        }
        this.update()
        return this;
    }
    getTimeline(): Timeline {
        return this.timeline;
    }
    update(): TimelineControls {
        if( this.timeline ){
            this.container.style.display = 'block';
            Object.keys(this.buttonUpdaters).forEach( (button:TimelineControlButtons) => {
                this.buttonUpdaters[button]();
            });
            
            if(this.lastModifiedDate === undefined ){
                const rangeWindow = <HTMLDivElement>this.container.querySelector('div.pseudo-window');
                if(rangeWindow.classList.contains('open')){
                    const range = this.getTimeline().getTimeRange(false);
                    this.startPicker.setDate( new Date(range.visible.start) );
                    this.endPicker.setDate( new Date(range.visible.end) );
                }
            }
        } else {
            //hide ourselves
            this.container.style.display = 'none';
        }
        return this;
    }
}


export class TimelineExternals {
    private buttonUpdaters: {[key in TimelineControlButtons]?:  () => void };

    private GRANULARITY_PATTERNS: {[key:string]: string } = {
            'millis': 'YYYY-MM-DD&nbsp;&nbsp;&nbsp;&nbsp;HH:mm:ss.SSS',
            'seconds': 'YYYY-MM-DD&nbsp;&nbsp;&nbsp;&nbsp;HH:mm:ss',
            'minutes': 'YYYY-MM-DD&nbsp;&nbsp;&nbsp;&nbsp;HH:mm',
            'hours': 'YYYY-MM-DD&nbsp;&nbsp;&nbsp;&nbsp;HH:00',
            'days': 'YYYY-MM-DD',
            'months': 'YYYY-MM',
            'years': 'YYYY'
    };

    public container:HTMLElement; 
    private timeline: Timeline;
    private timelineSubscription:Subscription;


    constructor( containerSelector: string ){
        this.container = <HTMLElement>document.querySelector(containerSelector);
        this.timeline = undefined;
        this.timelineSubscription = undefined;

        if( this.container ){
        } else {
            throw `Container '${containerSelector}' did not yield an element. Unable to setup TimelineExternals.`;
        }
    }
    
    setTimeline( timeline : Timeline ): TimelineExternals {
        if(this.timelineSubscription && !this.timelineSubscription.closed){
            this.timelineSubscription.unsubscribe();
            this.timelineSubscription = undefined;
        }
        
        this.timeline = timeline ? timeline : undefined;
        if(this.timeline){
            this.timeline.subsscribeToTimeCursor( () => this.update(), () => this.update() );

//            this.timelineSubscription = eventObserver( this.timeline.getContainer(), TimelineEvents.UPDATE_CONTROLS ).subscribe( event => this.update() );
        }
        this.update()
        return this;
    }
    
    getTimeline(): Timeline {
        return this.timeline;
    }
    
    update(): TimelineExternals {
        if( this.timeline ){
            
            const cursorMillis = this.timeline.getCursorMillis(true);
            if( cursorMillis ){
                this.container.style.display = '';
                const granularity = this.timeline.getGranularity();
                this.container.querySelector('span').innerHTML = this.millisToTimestampLabel( cursorMillis.center, granularity );
            }else{
                this.container.style.display = '';
            }
            
        } else {
            //hide ourselves
            this.container.style.display = 'none';
        }
        return this;
    }
    
    millisToTimestampLabel( millis:number, granularity:string ): string {
        const date = new Date(millis);
        var era = (date.getFullYear() <= 0 ? ' CE' : '');
        var YYYY = `${date.getFullYear()}`;
        var MM = `${(date.getMonth() < 9 ? '0' : '')}${date.getMonth()+1}` ;
        var DD = `${(date.getDate() < 10 ? '0' : '')}${date.getDate()}` ;
        var HH = `${(date.getHours() < 10 ? '0' : '')}${date.getHours()}` ;
        var mm = `${(date.getMinutes() < 10 ? '0' : '')}${date.getMinutes()}` ;
        var ss = `${(date.getSeconds() < 10 ? '0' : '')}${date.getSeconds()}` ;
        var SSS = `${(date.getMilliseconds() < 10 ? '00' : date.getMilliseconds() < 100 ? '0': '')}${date.getMilliseconds()}` ;
        
        return `${this.GRANULARITY_PATTERNS[granularity].replace('YYYY', YYYY).replace('MM',MM).replace('DD',DD).replace('HH',HH).replace('mm',mm).replace('ss',ss).replace('SSS',SSS)}${era}`;

    }
}

export const setupTimeline = (timelineSelector:string, timelineOptions:any, application?:Application, timelineControlsSelector?:string, timelineExternalsSelector?:string ) => {
    
    let timeline = new com.tlmapp.timeline.Timeline(timelineSelector, timelineOptions);
    let timelineWindow = timeline.getContainer().parentElement;
    //take measurements
//    let tlBottom = parseFloat (window.getComputedStyle(timelineWindow).bottom );
//    let tlStyleLeft = parseInt(window.getComputedStyle(timelineWindow).left);
//    let tlStyleRight = window.getComputedStyle(timelineWindow).right;

    let timelineControls = undefined;
    let timelineExternals = undefined;
    
    if( timelineControlsSelector ) {
        timelineControls = new TimelineControls( timelineControlsSelector,  );
        timelineControls.setTimeline(timeline);
        let timelineControlsWindow = timelineControls.container;
        //prepare for some measurements
        timelineControlsWindow.style.visibility = 'hidden';
        timelineControlsWindow.style.display = 'block';
        //take measurements
//        let tlcHeight = parseFloat( window.getComputedStyle(timelineControlsWindow).height );
//        let tlcStyleBottom = '0px';//`${tlBottom - tlcHeight - 33+12}px`;
 
        //apply measurements and show
//        timelineControlsWindow.style.bottom = tlcStyleBottom;
//        timelineControlsWindow.style.left = tlStyleLeft + 200+'px';
        timelineControlsWindow.style.visibility = '';

    }
    if( timelineExternalsSelector ){
        timelineExternals = new TimelineExternals( timelineExternalsSelector );
        timelineExternals.setTimeline(timeline);
//        let timelineExternalsWindow = timelineExternals.container;
//        //prepare for some measurements
//        timelineExternalsWindow.style.visibility = 'hidden';
//        timelineExternalsWindow.style.display = 'block';
//        //take measurements
//        let tleHeight = parseFloat( window.getComputedStyle(timelineExternalsWindow).height );
//        let tleStyleBottom = `${tlBottom - tleHeight}px`; 
//        //apply measurements and show
//        timelineExternalsWindow.style.bottom = tleStyleBottom;
//        timelineExternalsWindow.style.right = tlStyleRight;
//        timelineExternalsWindow.style.visibility = '';
    }
    if( application ){
        application.setMainTimeline(timeline);
    }
    
}
/*





    var buttonSelectorPrefix = timelineControlsSelector + ' div.timeline-buttons ';
    timelineOptions.buttons = {
        'control': buttonSelectorPrefix + 'a.control',
        'animateStop': buttonSelectorPrefix + 'a.stop',
        'animateStart': buttonSelectorPrefix + 'a.start',
        'animatePause': buttonSelectorPrefix + 'a.pause',
        'synchronize': buttonSelectorPrefix + 'a.synchronize',
        'reset': buttonSelectorPrefix + 'a.reset',
        'zoomIn': buttonSelectorPrefix + 'a.zoomIn',
        'zoomOut': buttonSelectorPrefix + 'a.zoomOut'
    };

    let timelineControls = new TimelineControls(timelineControlsSelector);
    
    let mainTimeline:Timeline = new com.tlmapp.timeline.Timeline(timelineSelector, timelineOptions);
    
    timelineControls.setTimeline(mainTimeline);
    
    
    application.setMainTimeline(mainTimeline);

    var $mainTimelineWindow = mainTimeline.getContainer().parentElement;
    var $mainTimelineControlsWindow = $(timelineControlsSelector);
    
    let $mainTimelineWindowStyle = window.getComputedStyle($mainTimelineWindow);

    var bottom = $mainTimelineWindowStyle.bottom;
    var height = $mainTimelineWindowStyle.height;
    
    var controlsBottom = height + Number(bottom.substring(0, bottom.length - 2));
    $mainTimelineControlsWindow.css({'bottom': '' + controlsBottom + 'px', 'display': 'block'});

    timelineControls.update();

    var mainTimelineControlsWindowContentNode = $mainTimelineControlsWindow.children('>div.content')[0];

    var $pseudoWindow = $('div.pseudo-window', mainTimelineControlsWindowContentNode);

    $('div#mainTimelineControls a', mainTimelineControlsWindowContentNode).on('click', function (evt) {
        evt.preventDefault();
    });

    $('div.timeline-buttons a.zoomIn', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().zoom(1);

    });
    $('div.timeline-buttons a.zoomOut', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().zoom(-1);
    });
    $('div.timeline-buttons a.reset', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().reset();
    });
    $('div.timeline-buttons a.synchronize', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().synchronize();
    });
    $('div.timeline-buttons a.stop', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().stopAnimation();
    });
    $('div.timeline-buttons a.start', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().startAnimation();
    });
    $('div.timeline-buttons a.pause', mainTimelineControlsWindowContentNode).on('click', function (event) {
        application.getMainTimeline().pauseAnimation();
    });
    $(mainTimeline.getContainer()).on(com.tlmapp.timeline.TRIG_NEW_HEIGHT, function (event, height) {
        var bottom = $mainTimelineWindowStyle.bottom;
        var controlsBottom = height + Number(bottom.substring(0, bottom.length - 2));
        $mainTimelineControlsWindow.css({'bottom': '' + controlsBottom + 'px'});
    });

    // picker functionality

    var $pickerDiv = $("div.dateTimePicker", mainTimelineControlsWindowContentNode);
    var $startPick = $("a.pickStart", mainTimelineControlsWindowContentNode);
    var $endPick = $("a.pickEnd", mainTimelineControlsWindowContentNode);
    var $pickerWindow = $("div.pseudo-window", mainTimelineControlsWindowContentNode);

    var picker = $pickerDiv.datetimepicker({
        inline: true,
        sideBySide: true,
        // capital H => 24hours format, even though the actual format doesn't really matter here
        format: "DD/MM/YYYY HH:mm",
        // don't depend on the glyphicon component of bootstrap (which is removed at some point)
        icons: {
            next: "icon-right-dir",
            previous: "icon-left-dir",
            up: "icon-up-dir",
            down: "icon-down-dir"
        }
    });

    // switching "pickers"
    $startPick.on("click", function () {
        $startPick.toggleClass("active");
        $endPick.toggleClass("active");
        picker.data("DateTimePicker").date(moment($pickerDiv.data('start')));
    });

    $endPick.on("click", function () {
        $startPick.toggleClass("active");
        $endPick.toggleClass("active");
        picker.data("DateTimePicker").date(moment($pickerDiv.data('end')));
    });

    var timeRange = mainTimeline.getTimeRange();

    // propagate stored data to active picker on show
    $("a.control", mainTimelineControlsWindowContentNode).on('click', function () {
        if (!$pickerWindow.hasClass("in")) { // opening
            if ($startPick.hasClass("active"))
                picker.data("DateTimePicker").date(moment($pickerDiv.data("start")));
            else
                picker.data("DateTimePicker").date(moment($pickerDiv.data("end")));
        }
    });

    $pickerDiv.on("dp.change", function (evt) {
        var msVal = evt.date.valueOf();
        if ($startPick.hasClass("active"))
            $pickerDiv.data("start", msVal);
        else
            $pickerDiv.data("end", msVal);
    });

    var closePicker = function () {
        var start = $pickerDiv.data("start");
        var end = $pickerDiv.data("end");
        mainTimeline.setRange(start, end);
        $pickerWindow.collapse('hide');
    };

    $("a.applyTimelineSettings", mainTimelineControlsWindowContentNode).on('click', closePicker);

    // convenience buttons, add/subtract a timerange depending on which picker is currently active

    var addRange = function (range) {
        // if the start picker is active, add the range to the start date and close
        // otherwise subtract the range from the current end date and close
        if ($startPick.hasClass("active")) {
            $pickerDiv.data('end', moment($pickerDiv.data('start')).add(range));
        }
        else {
            $pickerDiv.data('start', moment($pickerDiv.data('end')).subtract(range));
        }

        // uncomment if we just want to set it, but not close
        closePicker();
    };

    $("a.day", mainTimelineControlsWindowContentNode).on('click', function () {
        addRange(moment.duration(1, "days"));
    });
    $("a.week", mainTimelineControlsWindowContentNode).on('click', function () {
        addRange(moment.duration(7, "days"));
    });
    $("a.month", mainTimelineControlsWindowContentNode).on('click', function () {
        addRange(moment.duration(1, "months"))
    });
    $("a.year", mainTimelineControlsWindowContentNode).on('click', function () {
        addRange(moment.duration(1, "years"))
    });

    // initial data
    if (timeRange !== null) {
        $pickerDiv.data('start', timeRange.visible.start);
        $pickerDiv.data('end', timeRange.visible.end);
    }

    mainTimeline.get$Div().on(com.tlmapp.timeline.TRIG_NEW_TIME_RANGE, function (event, timeRange) {
        // don't update the picker data from a moving timeline while the picker itself is showing
        // otherwise it gets pretty rough on high zoom levels
        if (!$pseudoWindow.hasClass("collapse in")) {
            $pickerDiv.data('start', timeRange.visible.start);
            $pickerDiv.data('end', timeRange.visible.end);
        }
    });
};
*/
